/* src/app/home/partials/open-vehicle-defects/open-vehicle-defects.component.scss */
b {
  color: #1e293b;
  font-size: 0.95rem;
}
hr {
  margin: 0.5rem 0 0.75rem;
  border-color: #eef2f6;
}
.emptyState {
  color: #64748b;
  font-size: 0.85rem;
}
.defectList {
  list-style: none;
  margin: 0;
  padding: 0;
}
.defectList li {
  display: flex;
  flex-direction: column;
  padding: 0.55rem 0;
  border-top: 1px solid #f1f5f9;
  font-size: 0.85rem;
}
.defectList li:first-child {
  border-top: none;
}
.defectList strong {
  color: #1e293b;
}
.defectList span {
  color: #64748b;
}
/*# sourceMappingURL=open-vehicle-defects.component.css.map */
